import { components, services } from '@/utils'

import { className as documentationClassName } from '@/components/services/documentation/utils'

import render from './render'

export default {
  name: 'SimpleLayout',

  computed: {
    contentClass() {
      const [ routeService ] = String(this.$route.name).split('.')
      if (routeService === documentationClassName) {
        return `${components.content}--center-vertical`
      }

      return `${components.content}--center`
    },

    links() {
      const result = []
      switch (this.$route.name) {
        case services.login: {
          result.push(services.registration)
          break
        }

        default: {
          result.push(services.login)
          break
        }
      }
      result.push('documentation')
      result.push('debug')

      return result
    }
  },

  render
}
